import React, {useEffect, useState} from 'react';
import {useRouter} from 'next/router';

interface HistoryContextData {
    isPoppedState: boolean;
}

const HistoryContext = React.createContext<HistoryContextData>({isPoppedState: false});

const HistoryContextProvider: React.FC = ({children}) => {
    const router = useRouter();
    const [isPoppedState, setIsPoppedState] = useState(false);

    process.browser &&
        useEffect(() => {
            let flag = false;
            const cachedScrollOffset: number[] = [];
            let scrollY = 0;

            router.beforePopState(() => {
                scrollY = cachedScrollOffset.pop() || 0;
                flag = true;

                return true;
            });

            const onStart = () => {
                cachedScrollOffset.push(window.scrollY);
                if (flag) {
                    setIsPoppedState(true);
                } else {
                    setIsPoppedState(false);
                }
            };

            const onComplete = () => {
                window.scrollTo(0, scrollY);
                scrollY = 0;
                flag = false;
            };

            router.events.on('routeChangeStart', onStart);
            router.events.on('routeChangeComplete', onComplete);

            return () => {
                router.events.off('routeChangeStart', onStart);
                router.events.off('routeChangeComplete', onComplete);
            };
        }, []);

    return <HistoryContext.Provider value={{isPoppedState: isPoppedState}}>{children}</HistoryContext.Provider>;
};

export {HistoryContext};

export default HistoryContextProvider;
